module.exports = __webpack_public_path__ + "img/image-placeholder-medium.88930970.jpg";